<template>
	<div
		v-if="hasPrice && priceInfo.PriceWithoutTax !== null"
		class="h3 configurator-additional-info">
		Oplage: <strong>{{ getOrderLine.amount }}</strong>
	</div>
</template>

<script>
export default {
	name: "PriceAmount",
	computed: {
		hasPrice () {
			return this.$store.getters.getPrice.PriceWithoutTax != null;
		},
		priceInfo () {
			return this.$store.getters.getPrice;
		},
		getOrderLine () {
			return this.$store.getters.getOrderLine;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/element/price-amount.vue